import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
	const { pathname } = useLocation();
	const navigate = useNavigate();
	// Routes whose hero is a full-bleed photo running under the navbar; the
	// bar wears its dark-glass style there from the start.
	const overPhotoHero = pathname === "/" || /^\/producten\/.+/.test(pathname);
	const [click, setClick] = useState(false);
	const [dropdown, setDropdown] = useState(false);
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 960);
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		let raf = 0;
		const onScroll = () => {
			if (raf) return;
			raf = requestAnimationFrame(() => {
				setScrolled(window.scrollY > 24);
				raf = 0;
			});
		};
		window.addEventListener("scroll", onScroll, { passive: true });
		onScroll();
		return () => {
			window.removeEventListener("scroll", onScroll);
			if (raf) cancelAnimationFrame(raf);
		};
	}, []);

	const handleClick = () => setClick(!click);
	const closeMobileMenu = () => {
		setClick(false);
		setDropdown(false); // Close dropdown when closing mobile menu
	};

	const toggleDropdown = () => setDropdown(!dropdown);

	// Detect screen size to adjust dropdown behavior
	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 960);
		};
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

    const handleContactClick = (e) => {
        e.preventDefault();
        closeMobileMenu();

        // On the homepage, glide to the contact section; everywhere else,
        // go to the dedicated contact page.
        if (pathname === "/") {
            const contactForm = document.querySelector('.contact-form-container');
            if (contactForm) {
                contactForm.scrollIntoView({ behavior: 'smooth' });
                return;
            }
        }
        navigate("/contact");
    };

    return (
        <nav
            className={`navbar ${scrolled ? "navbar--scrolled" : ""} ${
                overPhotoHero && !click ? "navbar--over-hero" : ""
            }`}>
            <div className="navbar-container">
                <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
                    <img
                        src={require("../images/V-2.png")}
                        alt="Logo"
                        style={{ maxWidth: "64px", maxHeight: "64px" }}
                    />
                </Link>
                <a href="tel:0618218292" className="phone-container">
                    <i className="fas fa-phone"></i>
                    <span>06-18218292</span>
                </a>
                <div className="menu-icon" onClick={handleClick}>
                    <i className={click ? "fas fa-times" : "fas fa-bars"}></i>
                </div>
                <ul className={click ? "nav-menu active" : "nav-menu"}>
                    <li className="nav-item">
                        <Link to="/" className="nav-links" onClick={closeMobileMenu}>
                            HOME
                        </Link>
                    </li>
    
                    <li className="nav-item dropdown">
                        <div className="nav-links" onClick={toggleDropdown}>
                            PRODUCTEN
                            <i className="fas fa-caret-down mobile-caret"></i>
                        </div>
                        <ul className={`dropdown-menu ${dropdown ? "show" : ""} ${isMobile ? "mobile-dropdown" : ""}`}>
                            <li>
                                <Link to="/producten/cijfers_en_letters" className="dropdown-link" onClick={closeMobileMenu}>
                                    LED CIJFERS & LETTERS
                                </Link>
                            </li>
                            <li>
                                <Link to="/producten/verlichting" className="dropdown-link" onClick={closeMobileMenu}>
                                    VERLICHTING
                                </Link>
                            </li>
                            <li>
                                <Link to="/producten/ballondecoratie" className="dropdown-link" onClick={closeMobileMenu}>
                                    BALLONDECORATIE
                                </Link>
                            </li>
                            <li>
                                <Link to="/producten/photobooth" className="dropdown-link" onClick={closeMobileMenu}>
                                    PHOTOBOOTH
                                </Link>
                            </li>
                            <li>
                                <Link to="/producten/dansvloer" className="dropdown-link" onClick={closeMobileMenu}>
                                    LED-DANSVLOER
                                </Link>
                            </li>
                        </ul>
                    </li>
    
                    <li className="nav-item">
                        <Link to="/portfolio" className="nav-links" onClick={closeMobileMenu}>
                            PORTFOLIO
                        </Link>
                    </li>

                    <li className="nav-item">
                        <Link to="/prijslijst" className="nav-links" onClick={closeMobileMenu}>
                            PRIJSLIJST
                        </Link>
                    </li>

                    <li className="nav-item">
                        <Link to="/bestellen" className="nav-links" onClick={closeMobileMenu}>
                            BESTELLEN
                        </Link>
                    </li>
    
                    <li className="nav-item">
                        <a href="/contact" className="nav-links" onClick={handleContactClick}>
                            CONTACT
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    );
}

export default Navbar;
